import React, { useMemo } from 'react';

import Address from './address';
import Address2 from './address_2';
import City from './city';
import Country from './country';
import County from './county';
import State from './state';
import Zip from './zip';

import type { Address as AddressType, Country as CountryType, InputsOptions } from './types';

interface Props {
  children?: React.ReactNode;
  countries: CountryType[];
  // TODO: This should be optional
  options: InputsOptions;
  value: AddressType;
  onChange: (address: AddressType) => void;
}

export default function AddressForm({ children, countries, options, value, onChange }: Props) {
  const country = useMemo(() => countries.find((country) => country.code === value.countryId)!, [value.countryId]);

  const props = { countries, country, options, value, onChange };

  return <>
    <Country {...props} />
    <Address {...props} />
    <Address2 {...props} />
    {children}
    <City {...props} />
    <State {...props} />
    <Zip {...props} />
    <County {...props} />
  </>;
}
